import VimeoPlayer from '../components/VimeoPlayer';

const nlVimeo = document.querySelectorAll('[data-vimeo]');

nlVimeo.forEach(el => new VimeoPlayer(el));
